import React from "react";
import { Tooltip } from "react-tooltip";
export function MyTooltip({ id, content }) {
  return (
    <Tooltip
      id={id}
      place="bottom"
      content={content}
      effect="solid"
      delayShow={800} // delay before showing (ms)
      delayHide={200}
    />
  );
}
